import { render, staticRenderFns } from "./BLItemCredit.vue?vue&type=template&id=6827874b&"
import script from "./BLItemCredit.vue?vue&type=script&lang=js&"
export * from "./BLItemCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports